export const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
